import { configureStore } from "@reduxjs/toolkit";
import productReducer from "./slices/productSlice";
import galleryReducer from "./slices/gallerySlice";
import contactReducer from "./slices/contactSlice";
import uiReducer from "./slices/uiSlice";
import authReducer from "./slices/authSlice";
import sliderReducer from "./slices/sliderSlice";

export default configureStore({
  reducer: {
    products: productReducer,
    gallery: galleryReducer,
    contact: contactReducer,
    ui: uiReducer,
    auth: authReducer,
    slider: sliderReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});
